import PaginationURL from "util/PaginationURL";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { SOURCE_URL } from "report/Constants";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
const fetchReports = (searchParams) => {
  const url = PaginationURL(
    `${SOURCE_URL}/reports/paginated`,
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    {
      sort: searchParams.sort.attributeId,
      order: searchParams.sort.direction,
      filters: FiltersForQueryParams(searchParams.filters)
    }
  );
  return fetch("GET", qualifyUrl(url)).then(
    ({ elements, total, count, page, per_page: perPage, attributes }) => ({
      list: elements,
      pagination: { total, count, page, perPage },
      attributes
    })
  );
};
export default fetchReports;
